<template>
  <b-row>
    <b-col cols="12">
      <div
        v-if="error"
        class="alert alert-dismissible alert-danger"
        role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true"></span> {{ error }}
      </div>
      <div
        v-if="deleteError"
        class="alert alert-dismissible alert-danger"
        role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true"></span> {{ deleteError }}
      </div>
    </b-col>
    <b-col cols="12">
      <b-row>
        <b-col>
          <router-link :to="{ name: 'InternalAnnouncementList' }" class="btn btn-default float-right">{{$t('buttons.backToList')}}</router-link>
        </b-col>
      </b-row>
    </b-col>
    <b-col cols="12">
      <div class="card p-2">
        <template v-if="isLoading">
          <Loader></Loader>
        </template>
        <template v-else>
          <div v-if="item">
            <p v-if="item.createdAt">
              <b>{{$t('views.application.show.created')}}</b> - {{$moment(item.createdAt).format('YYYY-MM-DD HH:mm')}}
            </p>
          </div>
          <div v-if="item">
            <p><b>{{$t('buttons.preview')}}</b></p>
            <b-row>
              <b-col>
                <table class="table table-striped table-hover mt-4">
                  <thead>
                  <tr>
                    <th>{{$t('views.application.show.application')}}</th>
                    <th>{{$t('views.application.show.executeReturn')}}</th>
                    <th>{{$t('views.application.show.executedAt')}}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="i in item.internalAnnouncementApplication" :key="i['@id']">
                    <td>
                      <p>{{i.application.subdomain}}</p>
                    </td>
                    <td>
                      <p>{{ i.executeReturn }}</p>
                    </td>
                    <td>
                      <p>{{$moment(i.updatedAt).format('YYYY-MM-DD HH:mm')}}</p>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </b-col>
              <b-col>
                <internal-announcement-content :content="item.content"></internal-announcement-content>
              </b-col>
            </b-row>
          </div>
        </template>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { DATETIMEFORMATTYPE } from '@/config/datetimeFormatType'
import { mapActions, mapGetters } from 'vuex'
import Loader from '../../../Layout/Loader'
import InternalAnnouncementContent from '@/components/Dashboard/Views/IAMBundle/internalannouncement/internalAnnouncementContent.vue'

export default {
  components: {
    InternalAnnouncementContent,
    Loader
  },
  data () {
    return {
      DATETIMEFORMATTYPE,
      executedApplicationFields: [
        {
          key: 'application',
          label: this.$lang.t('views.application.show.application')
        },
        {
          key: 'executeReturn',
          label: this.$lang.t('views.application.show.executeReturn')
        },
        {
          key: 'createdAt',
          label: this.$lang.t('views.application.show.executedAt'),
          sortable: true
        }
      ]
    }
  },
  computed: mapGetters({
    deleteError: 'internalannouncement/del/error',
    error: 'internalannouncement/show/error',
    isLoading: 'internalannouncement/show/isLoading',
    item: 'internalannouncement/show/retrieved'
  }),

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      del: 'internalannouncement/del/del',
      reset: 'internalannouncement/show/reset',
      retrieve: 'internalannouncement/show/retrieve'
    })
  }
}
</script>
